import React from "react";
import "./Danhgia.css";



const reviews = [
  {
    id: 1,
    name: "Anh Hoàng",
    tag: "Nhanh chóng",
    image: "/m1.jpg",
    text: "Mình cần rút gấp buổi tối, nhắn Zalo là có người phản hồi ngay. Làm khá nhanh, khoảng vài phút là xong. Điểm mình thích là không phải chờ đợi như mấy chỗ khác.",
  },
  {
    id: 2,
    name: "Chị Ngọc",
    tag: "Minh bạch",
    image: "/g1.jpg",
    text: "Trước khi làm họ báo phí rõ ràng, mình biết trước sẽ nhận bao nhiêu nên khá yên tâm. Không thấy phát sinh thêm gì sau đó.",
  },
  {
    id: 3,
    name: "Anh Duy",
    tag: "Tận tâm",
    image: "/m2.jpg",
    text: "Mình tự quẹt thẻ trên máy nên cảm thấy an toàn hơn. Không phải đưa thẻ cho người khác giữ nên đỡ lo.",
  },
  {
    id: 4,
    name: "Chị Linh",
    tag: "Phản hồi nhanh",
    image: "/g2.jpg",
    text: "Có hỗ trợ tận nơi nên khá tiện, không cần đi đâu. Phù hợp khi cần rút gấp mà không muốn di chuyển.",
  },
  {
    id: 5,
    name: "Anh Khang",
    tag: "Dễ làm việc",
    image: "/m3.jpg",
    text: "Dịch vụ ổn, xử lý nhanh, tư vấn cũng rõ ràng. Nếu cần gấp thì đây là lựa chọn hợp lý, còn không gấp thì nên cân nhắc nhu cầu trước.",
  },
  {
    id: 6,
    name: "Chị Trâm",
    tag: "Hỗ trợ tốt",
    image: "/g3.jpg",
    text: "Ban đầu cũng hơi lo nhưng sau khi được giải thích kỹ và làm thử thì thấy quy trình khá rõ ràng. Quan trọng là họ cho mình biết trước mọi thứ rồi mới làm.",
  },
];

export default function Danhgia() {
  return (
    <section className="customer-reviews">
      <div className="customer-reviews__container">
        <div className="customer-reviews__heading">
          <h2>Khách hàng nói gì về chúng tôi</h2>
        </div>

        <div className="customer-reviews__grid">
          {reviews.map((item) => (
            <div className="customer-reviews__card" key={item.id}>
              <div className="customer-reviews__top">
                <img
                  src={item.image}
                  alt={item.name}
                  className="customer-reviews__avatar"
                />

                <div className="customer-reviews__info">
                  <h3>{item.name}</h3>
                </div>
              </div>

              <div className="customer-reviews__stars">★★★★★</div>

              <p className="customer-reviews__text">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}